const userGuide = {
  openGuide: "Ouvrir le guide d'utilisateur",
  unavailable: "Le guide d'utilisateur n'est pas disponible pour le moment. Réessayez plus tard ou écrivez à <emailLink>{{email}}</emailLink>.",
};

export default userGuide;
